import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataService } from 'src/app/main/shared/services/data.service';
import { GisDimsMapComponent } from 'src/app/main/shared/gis-dims-map/gis-dims-map.component';

@Component({
  selector: 'app-wind-speed-forecast-sidebar',
  templateUrl: './wind-speed-forecast-sidebar.component.html',
  styleUrls: ['./wind-speed-forecast-sidebar.component.scss']
})
export class WindSpeedForecastSidebarComponent implements OnInit {

  @Input() labelStrings: any;
  @Input() blockNum: number;
  @Output() playPos = new EventEmitter<any>();
  selected: string;
  queryParams: {};
  isInitialLoad: boolean = false;
  dateIndexLength: any;
  activeRadioList: boolean[] = [];
  modalRef: any;
  sourceOptions: any = ['IMD', 'ECMWF', 'IMD(WRF + GFS)'];
  selectedSource: any;
  sourceMapping = {
    'IMD': 'IMD_LONG_RANGE',
    'ECMWF': 'ECMWF',
    'IMD(WRF + GFS)': 'IMD_SHORT_RANGE'
  };
  destroy: any = new Subject();
  sessionStorage: any = { params: {} };
  constructor(
  private router: Router,
  private route: ActivatedRoute,
  private gisUtils: UtilsService,
  private dataService: DataService,
  private gisMapComp: GisDimsMapComponent
) {
  this.selected = this.router.url.split("/")[2];
}


  ngOnInit() {
    this.isInitialLoad = true;
    this.subscribeEvents();
    this.setParams();
  }

  subscribeEvents() {
    this.gisUtils.selectedParams
      .pipe(takeUntil(this.destroy))
      .subscribe((params: any) => {
        const sessionStorageSelectedParams: any = sessionStorage.getItem('params');
        if (Object.keys(params).length > 0) {
          this.queryParams = params;
        } else {
          this.queryParams = sessionStorageSelectedParams ? JSON.parse(sessionStorageSelectedParams) : {};
          this.sessionStorage.params = { ...this.queryParams };
          if (Object.keys(this.queryParams).length) {
            this.gisUtils.setSelectedParams(this.queryParams);
          }
        }
        if (!isNullOrUndefined(this.queryParams) && Object.keys(this.queryParams).length > 0) {
          this.selectedSource = this.queryParams['source'] === 'IMD_LONG_RANGE' ? 'IMD'
            : this.queryParams['source'] === 'IMD_SHORT_RANGE' ? 'IMD(WRF + GFS)'
              : this.queryParams['source'];
          this.dateIndexLength = this.queryParams['forecastLength'] === '24' ? 9 : this.queryParams['forecastLength'] === '-7D' ? 8 : 7;
          this.activeRadioList = [];
          for (let i = 0; i < this.dateIndexLength; ++i) {
            this.activeRadioList.push(i === this.blockNum);
          }
        }
      });
  }
  setParams() {
    if (this.isInitialLoad && !Object.keys(this.sessionStorage.params).length) {
      this.requestSelectedFilterParams();
    }
    this.isInitialLoad = false;
  }

  ngOnChanges(change: SimpleChanges) {
    // let timeStamp = this.labelStrings[this.blockNum].groupName;
    // this.gisUtils.setTimeStamp(timeStamp)
    if (!isNullOrUndefined(change.blockNum) && this.labelStrings && this.labelStrings.length > 0) {
      if (!isNullOrUndefined(change.blockNum.currentValue)) {
        this.buttonClicked(change.blockNum.currentValue);
      }

    } else {
      this.buttonClicked(this.blockNum);
    }
    const total = (this.labelStrings && this.labelStrings.length)
      ? this.labelStrings.length
      : (this.dateIndexLength || 0);
    this.activeRadioList = [];
    for (let i = 0; i < total; ++i) {
    this.activeRadioList.push(i === this.blockNum);
    }
  }

  // requestSelectedFilterParams() {
  //   let currentUrlParams: any = {};
  //   if (!this.isInitialLoad) {
  //     currentUrlParams = { ...this.queryParams };
  //  }
  //   currentUrlParams['component'] = 'WINDSPEEDFORECAST';
  //   currentUrlParams['src'] = 'IMD_GRID'
  //   if (this.isInitialLoad) {
  //     currentUrlParams['actionType'] = 'filter';
  //     currentUrlParams['view'] = 'ADMIN';
  //     currentUrlParams['pType'] = 'COUNTRY';
  //     currentUrlParams['cType'] = 'STATE';
  //     currentUrlParams['parentLoc'] = 'COUNTRY';
  //     currentUrlParams['dashboardView'] = 'INDIA';
  //     this.gisUtils.setSelectedParams(currentUrlParams);
  //     this.isInitialLoad = false
  //   }
  //   console.log('params being sent:', currentUrlParams);
  // }


   requestSelectedFilterParams() {
    let currentUrlParams: any = {};
    if (!this.isInitialLoad) {
      currentUrlParams = this.queryParams;
    }
    currentUrlParams['component'] = 'WINDSPEEDFORECAST';
    if (this.isInitialLoad) {
      currentUrlParams['actionType'] = 'filter';
      currentUrlParams['view'] = 'Admin';
      currentUrlParams['pType'] = 'COUNTRY';
      currentUrlParams['cType'] = 'STATE';
      currentUrlParams['parentLoc'] = 'COUNTRY';
      currentUrlParams['dashboardView'] = 'INDIA';
      currentUrlParams['dashboardType'] = 'gis';
      const userLocationConfig = this.dataService.formQuerParamsVariables(this.gisMapComp.metaInfo.userDetailsJson.data.location, this.gisMapComp.metaInfo.userDetailsJson.data.locType);
      const currentLocations: any = userLocationConfig.locationInfo[userLocationConfig.types.pType.toLowerCase()].split('##');
      currentUrlParams['pUUID'] = currentLocations[1]
      currentUrlParams['locName'] = currentLocations[0]
      currentUrlParams['locType'] = userLocationConfig.types.pType;
      currentUrlParams['pEUUID'] = userLocationConfig.locationInfo.country.split('##')[1];
      currentUrlParams['location'] = userLocationConfig.locationInfo.location;
      currentUrlParams['forecastLength'] = '24';
      currentUrlParams['source'] = 'IMD_LONG_RANGE';
      this.isInitialLoad = false;
    }
    this.gisUtils.setSelectedParams(currentUrlParams);
  }
  buttonClicked(blockNumber, from?: string) {
    if (from === 'HTML') {
      this.playPos.emit(blockNumber);
    }
    if (this.activeRadioList[blockNumber]) {
      this.gisUtils.setIndex(this.labelStrings[blockNumber]['groupName']);
    }
  }

  validate(i) {
    if (this.labelStrings[i] == undefined || this.labelStrings[i] == null) {
      return ""
    }
    else {
      return this.labelStrings[i]['fullLabel'];
    }
  }

  sourceChange() {
    // this.gisUtils.setHeatWaveSource.next(this.sourceMapping[this.selectedSource]);
    let options = { ...this.queryParams }
    options['source'] = this.sourceMapping[this.selectedSource]
    console.log(options['source'], "options['source']")
    this.gisUtils.setSelectedParams(options);
  }
  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }
}

